import React from "react";
import cx from "classnames";

export default function Icon({
  name,
  xsmall,
  small,
  medium,
  large,
  onClick,
  className
}) {
  return (
    <i
      className={cx(
        "icon",
        `icon-${name}`,
        {
          "icon--xsmall": xsmall,
          "icon--small": small,
          "icon--medium": medium,
          "icon--large": large
        },
        className
      )}
      onClick={onClick}
    />
  );
}
